<template>
  <div class="container-fluid p-0">
    <PageTitle :title="pageTitle" :titleSave="$t('label.salvar')" :isAdd="false" v-on:onSave="save()" v-on:onCancel="cancel()" :nameEdit="nameEdit" :withOutExcluir="true"/>

    <!-- tabela -->
    <div class="row">
      <div class="col-12 d-flex">
          <div class="card flex-fill ">
            <div class="card-body box-dashboard p-3">
              <div class="align-self-center">
                <div class="row">
                  <div class="col-md-6">
                    <div class="mb-3 ">
                      <label for="municipio" class="form-label">{{ $t('label.municipio') }}</label>
                      <input class="form-control" type="text" v-model="form.municipio" :class="{ 'is-invalid': $v.form.municipio.$dirty && $v.form.municipio.$error }" disabled="disabled">
                      <div class="invalid-feedback">
                        {{ $t('message.requiredField') }}
                       </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="mb-3 ">
                      <label for="email_group" class="form-label">{{ $t('label.grupoDeEmails') }}</label>
                      <v-select multiple :appendToBody="true" :filterable="false" @search="getEmailGroup" :options="groupList" v-model="relMunicipiosEmailGroupSelected" label="name" index="email_group_id"
                          :reduce="r => r.email_group_id" :clearable="false" class="wf-select vue-select">
                          <template v-slot:selected-option="option">
                            {{ `${option.name}` }}
                          </template>
                          <template v-slot:option="option">
                            {{ `${option.name}` }}
                          </template>
                          <template v-slot:no-options="{ search, searching }">
                            <template v-if="searching">
                              {{`${ $t('message.noResultsFor') } `}}<em>{{ search }}</em>.
                            </template>
                          </template>
                        </v-select>
                      <div class="invalid-feedback">
                        {{ $t('message.requiredField') }}
                       </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import PageTitle from '@/components/shared/PageTitle'
import { required } from 'vuelidate/lib/validators'
export default {
  name: 'MunicipioForm',
  components: {
    PageTitle
  },
  data: function () {
    return {
      pageTitle: `${this.$t('label.municipio')} > Adicionar`,
      nameEdit: '',
      groupList: [],
      relMunicipiosEmailGroupSelected: [],
      action: this.$actionNew,
      form: {}
    }
  },
  validations: {
    form: {
      municipio: { required }
    }
  },
  methods: {
    getById: function (id) {
      this.$store.dispatch('showPreload')
      axios.get(`/VocMunicipios/${id}`)
        .then(response => {
          this.form = response.data
          this.nameEdit = ` ${this.form.municipio}`
          this.getRelMunicipiosEmailGroupSelected()
        })
    },
    getRelMunicipiosEmailGroupSelected: function () {
      this.relMunicipiosEmailGroupSelected = []
      this.form.relMunicipiosEmailGroup.forEach(e => {
        if (!this.relMunicipiosEmailGroupSelected.includes(e.email_group_id)) {
          this.relMunicipiosEmailGroupSelected.push(Number(e.email_group_id))
        }
      })
      this.getEmailGroup()
    },
    getEmailGroup: function (search, loading) {
      const params = {
        Page: 1,
        PageSize: 9999
      }
      if (search && search.length > 2) {
        params.name = search
        params.email_group_id_array = this.relMunicipiosEmailGroupSelected.join(',')
        loading(true)
        axios.get('/SysEmailGroup/getallcombo', { params })
          .then(response => {
            this.groupList = response.data.items
            loading(false)
          })
      } else if (!search) {
        params.email_group_id_array = this.relMunicipiosEmailGroupSelected.join(',')
        axios.get('/SysEmailGroup/getallcombo', { params })
          .then(response => {
            this.groupList = response.data.items
          })
      }
    },
    save: function () {
      this.$v.$touch()
      if (this.$v.form.$invalid) {
        return
      }
      this.form.relMunicipiosEmailGroup = []
      this.relMunicipiosEmailGroupSelected.forEach(el => {
        this.form.relMunicipiosEmailGroup.push({ email_group_id: el, municipio_id: this.form.municipio_id })
      })
      if (this.action === this.$actionEdit) {
        axios.put('/VocMunicipios', this.form)
          .then(() => {
            this.$toasted.global.saved()
            this.cancel()
          })
      } else {
        axios.post('/VocMunicipios', this.form)
          .then(() => {
            this.$toasted.global.saved()
            this.cancel()
          })
      }
    },
    cancel: function () {
      this.$router.replace('/admin/municipio')
    },
    excluir: function () {
      if (confirm(this.$t('message.confirmDel'))) {
        axios.delete(`/VocMunicipios/${this.form.municipio_id}`)
          .then(() => {
            this.$toasted.global.defaultSuccess()
            this.cancel()
          })
      }
    }
  },
  created: function () {
    this.getEmailGroup()
    this.action =
      this.$route.params.id !== this.$actionNew
        ? this.$actionEdit
        : this.$actionNew

    if (this.action === this.$actionEdit) {
      this.pageTitle = `${this.$t('label.municipio')} > Alterar`
      this.getById(this.$route.params.id)
    }
  }
}
</script>
